exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".analysisControls .infoBox{font-size:.8em}.analysisControls .infoBox .skillsetStandardLabel{font-size:inherit}.analysisControls .infoBox p:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/controls/analysis_controls.scss
// module id = 1509
// module chunks = 0